import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  TbArrowUpRight, TbBrandGithub, TbBrandLinkedin, TbBrandWhatsapp, TbDownload, TbMail, TbMapPin, TbPhone,
} from 'react-icons/tb';
import '../i18n';
import { CV_PATH, contact } from '../data/profile';
import Reveal from './Reveal';
import './assets/css/contact.css';

function Contact() {
  const { t } = useTranslation();

  const channels = [
    { icon: TbMail, label: 'Email', value: contact.email, href: `mailto:${contact.email}` },
    { icon: TbPhone, label: 'WhatsApp', value: contact.phone, href: contact.whatsapp },
    { icon: TbBrandLinkedin, label: 'LinkedIn', value: 'Tomás Bastiani', href: contact.linkedin },
    { icon: TbBrandGithub, label: 'GitHub', value: '@tomasbastiani', href: contact.github },
  ];

  return (
    <footer id="contact" className="contact">
      <div className="section-inner">
        <Reveal className="contact-card">
          <div className="contact-intro">
            <span className="section-eyebrow">{t('contact_eyebrow')}</span>
            <h2 className="section-title">{t('contact_title')}</h2>
            <p className="section-subtitle">{t('contact_text')}</p>
            <p className="contact-location"><TbMapPin aria-hidden="true" /> {t('hero_location')}</p>
            <div className="contact-cta">
              <a href={`mailto:${contact.email}`} className="btn-primary-grad">
                <TbMail /> {t('send_email')}
              </a>
              <a href={CV_PATH} download="CV_Tomas_Bastiani.pdf" className="btn-ghost">
                <TbDownload /> {t('downloadCV')}
              </a>
            </div>
          </div>

          <ul className="contact-channels">
            {channels.map(({ icon: Icon, label, value, href }) => (
              <li key={label}>
                <a href={href} target="_blank" rel="noopener noreferrer" className="channel">
                  <span className="channel-icon"><Icon aria-hidden="true" /></span>
                  <span className="channel-text">
                    <span className="channel-label">{label}</span>
                    <span className="channel-value">{value}</span>
                  </span>
                  <TbArrowUpRight className="channel-arrow" aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>
        </Reveal>

        <div className="footer-bar">
          <span>© {new Date().getFullYear()} Tomás Bastiani. {t('footer_built')}</span>
          <div className="footer-socials">
            <a href={contact.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><TbBrandLinkedin /></a>
            <a href={contact.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub"><TbBrandGithub /></a>
            <a href={contact.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><TbBrandWhatsapp /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Contact;
